module.exports = __webpack_public_path__ + "img/server.00a6fff5.svg";